module.exports = __webpack_public_path__ + "static/img/1.aec489a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/1.png
// module id = SLfS
// module chunks = 0